import { render } from "./TransactionsPage.vue?vue&type=template&id=515267be&scoped=true"
import script from "./TransactionsPage.vue?vue&type=script&lang=js"
export * from "./TransactionsPage.vue?vue&type=script&lang=js"

import "./TransactionsPage.vue?vue&type=style&index=0&id=515267be&scoped=true&lang=css"
import "./TransactionsPage.vue?vue&type=style&index=1&id=515267be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515267be"]])

export default __exports__